<template>
    <div class="d-flex justify-content-between  "
         :class="['main-navbar', 'bg-white' ,stickyTop ? 'sticky-top' : '']">
        <navbar-toggle class="d-md-none d-lg-none"/>

        
        <d-navbar type="light" class="d-none d-sm-block justify-content-sm-end justify-content-md-end justify-content-lg-end justify-content-end flex-md-nowrap p-0">
  
               
                <!-- <h6 v-if="userHasCompany" class="font-weight-bold text-left align-center mx-auto d-inline p-1">{{company}}</h6>-->
                
                <h6 class="font-weight-bold text-left align-center mx-auto d-inline p-1"> &nbsp;&nbsp;  </h6>

                <img  v-if="userHasLogo" class="align-center mx-auto d-inline" style=" height: 58px; margin-left: 5px; "
                             v-bind:src="logo" alt="">

                <img  v-if="!userHasLogo" class="align-center mx-auto d-inline" style=" height: 58px; margin-left: 5px; "
                             :src="logo" alt="">

        </d-navbar>

        <d-navbar type="light" class=" justify-content-sm-end justify-content-md-end justify-content-lg-end justify-content-end flex-md-nowrap p-0">
            <navbar-nav/>
        </d-navbar>
    </div>
</template>

<script>
    import NavbarNav from './NavbarNav.vue';
    import NavbarToggle from "./NavbarToggle";
    import api from "../../../utils/api/api";

    export default {
        components: {
            NavbarToggle,
            NavbarNav
        },
        data() {
            return {
                userHasLogo: false,
                userHasCompany: false,
                logo: undefined,
                company: undefined,
                urlimg: undefined,
            };
        },
        props: {
            /**
             * Whether the main navbar should be sticky, or not.
             */
            stickyTop: {
                type: Boolean,
                default: true,
            },
        },
        mounted: function () {
            //this.company = "Bioceres";
            //this.logo = "bioceres.png";

            this.urlimg = api.getUrlImages() + "/frontimg/" ;
            //console.log(this.urlimg);

            if(this.$store.state.user.empresa !== null )
            {
                //console.log(this.$store.state.user.empresa);
                this.company = this.$store.state.user.empresa;
                this.userHasCompany = true;
            }

            if(this.$store.state.user.logo !== null)
            {
                //console.log(this.$store.state.user.logo);
                this.logo = this.urlimg + this.$store.state.user.logo;
                this.userHasLogo = true;
            }
            else
            {
                this.logo =  this.urlimg + "blank.jpg";
                this.userHasLogo = true;
            }

            //console.log(this.logo);
    
            
        }, 
    };
</script>

<style lang="scss">
    .main-navbar {
        .dropdown-menu {
            display: block;
        }
    }
    .logobox {
        display: flex;
        width: 300px;
        height: 60px;
    }
</style>
